import { render, staticRenderFns } from "./AffiliateDashboard.vue?vue&type=template&id=dfc877d2&scoped=true&"
import script from "./AffiliateDashboard.vue?vue&type=script&lang=js&"
export * from "./AffiliateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateDashboard.vue?vue&type=style&index=0&id=dfc877d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc877d2",
  null
  
)

export default component.exports